import { render, staticRenderFns } from "./PolygonCompare.vue?vue&type=template&id=463fdc4b&"
import script from "./PolygonCompare.vue?vue&type=script&lang=js&"
export * from "./PolygonCompare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports